export default "__VITE_ASSET__BVeHaUL3__"